export const excessiveLetterPoints = [
    {letter: "a", minNum: 3, value: 6},
    {letter: "b", minNum: 3, value: 8},
    {letter: "c", minNum: 3, value: 11},
    {letter: "d", minNum: 3, value: 6},
    {letter: "e", minNum: 3, value: 3},
    {letter: "f", minNum: 3, value: 9},
    {letter: "g", minNum: 3, value: 5},
    {letter: "h", minNum: 2, value: 4},
    {letter: "i", minNum: 3, value: 6},
    {letter: "j", minNum: 2, value: 16},
    {letter: "k", minNum: 2, value: 19},
    {letter: "l", minNum: 3, value: 7},
    {letter: "m", minNum: 3, value: 6},
    {letter: "n", minNum: 4, value: 9},
    {letter: "o", minNum: 3, value: 5},
    {letter: "p", minNum: 3, value: 5},
    {letter: "q", minNum: 2, value: 18},
    {letter: "r", minNum: 3, value: 6},
    {letter: "s", minNum: 4, value: 8},
    {letter: "t", minNum: 3, value: 5},
    {letter: "u", minNum: 2, value: 8},
    {letter: "v", minNum: 2, value: 11},
    {letter: "w", minNum: 2, value: 14},
    {letter: "x", minNum: 2, value: 20},
    {letter: "y", minNum: 2, value: 9},
    {letter: "z", minNum: 2, value: 6}
];
